import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Button,
  Row
} from 'reactstrap';
import classNames from 'classnames';

import { getCollectionBySlug, fetchCollectionProduct } from '../../actions/productAction';
import FilterAndSort from "../../components/PageSearchDetails/FilterAndSort";
import { Banner, Content } from '../Assets';
import { getCloudImageUrl, isFromAppBrowser } from '../../utils/Helpers';
import SneakerLoadingSpinner from '../../components/Sneakers/SneakerLoadingSpinner';
import Sneaker from '../../components/Sneakers/Sneaker';
import { ASSET_IMAGE, RESOURCE_URL } from '../../config';
// import { getQueryParamsUrl } from "../../helpers/url";
import NotFoundImg from "../../images/dashboard-empty-state.png";

const CardNotFound = () => (
  <Container className="page-container" style={{ display: "flex" }}>
    <div style={{ flex: 1 }}>
      <div className="not-found" style={{ margin: "0 auto" }}>
        <div className="img-wrapper">
          <KickImage src={NotFoundImg} />
        </div>
      </div>
    </div>
  </Container>
);

class CollectionPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true
    }
  }

  componentDidMount() {
    const { dataCategory, computedMatch: { params: { category, slug } } } = this.props;

    this.props.getCollectionBySlug(dataCategory, slug)
    .then(() => {
      this.getProductList();
    })
    let options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.7
    };

    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  getQueryParamsUrl = () => {
    const checker = new URLSearchParams(this.props.location.search);
    let objParams = {};
    for (let pair of checker.entries()) {
      objParams = {
        ...objParams,
        [pair[0]]: pair[1]
      };
    }
    return objParams;
  }
  
  getProductList = () => {
    const { dataCategory, dataProduct: { id, slug, collectionType }, dataProducts } = this.props;
    const { page } = this.state;
    const queries = this.getQueryParamsUrl();

    let payload = {
      ...queries,
      page,
      availables: true,
      collection: slug,
      collection_type: collectionType,
      category: dataCategory,
      sort_by: dataProducts.caseSorting
    }

    if (slug === "1-day-delivery") payload.pre_verified = true

    this.props.fetchCollectionProduct(payload)
    .then(() => {
      this.setState({ page: page + 1 })
    })
  }

  handleObserver(entities, observer) {
    const { prevY, page } = this.state;
    const {
      dataProduct: {
        products: { hasMoreData, error }
      }
    } = this.props;

    const y = entities[0].boundingClientRect.y;
    if (hasMoreData !== null && !error) {
      if (prevY > y) {
        this.getProductList();
      }
      this.setState({ prevY: y });
    }
  }

  renderProducts = () => {
    const { isFetching: isLoading, error: errorCollection, slug, products: { data, isFetching, error } } = this.props.dataProduct;
    const queries = this.getQueryParamsUrl();
    const isPreVerified = Object.keys(queries).find((key) => key === "pre_verified");

    if ((!isLoading && errorCollection) || (!isFetching && error)) return <CardNotFound />;

    return(
      <div id="product">
        <Row>
          {
            data.map((item, index) => (
            <Sneaker 
              hotProducts={item.editors_choice} 
              {...item}
              category={this.props.dataCategory}
              key={index}
              outOfStock={item.out_of_stock}
              isPreVerified={isPreVerified} />
            ))
          }
        </Row>
      </div>
    )
  }

  render() {
    const { imageLandscape, imagePortrait, isFetching: isLoading, slug, collectionType, products: { data, isFetching } } = this.props.dataProduct;

    return (
      <Container fluid className="main-container" id="home-container">
        <div className="d-none d-sm-block">
          <Banner 
            src={getCloudImageUrl(imageLandscape, 1024)}
            alt={`${RESOURCE_URL}/assets-image/editors-pick-details.jpg`}
          />
        </div>
        <div className="d-block d-sm-none">
          <Banner 
            src={getCloudImageUrl(imagePortrait, 1024)}
            alt={`${RESOURCE_URL}/assets-image/editors-pick-details.jpg`}
          />
        </div>
        <div className="product-list">
        <div style={{ margin: "0px 15px"}}>
          <FilterAndSort
            history={this.props.history}
            match={this.props.match}
            typeFilter="SEARCH_PRODUCT"
            onResetPageNumber={() =>
              this.setState({ page: 1, isFetching: true })
            }
            isCollectionPage 
            isPreVerified={slug === "1-day-delivery"}
          />
        </div>
          {this.renderProducts()}
          <div style={{ marginTop: "120px" }}>
            <SneakerLoadingSpinner
              isLoading={isFetching && this.state.page > 1 || (isLoading && data.length === 0)}
              isHide={!isFetching}
              wrapperRef={loadingRef => this.loadingRef = loadingRef}
            />
          </div>
        </div>
        
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  dataProduct: state.dataProduct.collection,
  dataCategory: state.dataCategory.selected,
  dataProducts: state.dataProduct
})

const mapDispatchToProps = {
  getCollectionBySlug,
  fetchCollectionProduct
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPage);
